export { TcLogo } from "./TcLogo"
